import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=507d3a81&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d3a81",
  null
  
)

export default component.exports